<template>
  <Select v-model="curId" filterable clearable @change="onChange" size="mini">
    <Option
      :value="t.user.userId"
      :key="t.id"
      v-for="t in types"
      :label="t.task"
    >
      <div class="d-flex">
        <div class="avatar avatar-xs mg-r-5df">
          <img :src="t.user.avator" class="rounded-circle" />
        </div>
        <div>{{ t.user.fullName }}</div>
      </div>
    </Option>
  </Select>
</template>

<script>
import { request } from "@/api/all";
import { Select, Option } from "element-ui";
import { mapActions } from "vuex";

export default {
  components: { Select, Option },
  name: "hrmTagAssign",
  data() {
    return {
      types: [],
      curId: null
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["getGroupDefaultProjects"]),
    init() {
      request({
        api: { url: "TaskCore/GetCoreList", method: "POST" },
        data: {
          projectId: 53933,
          skip: 0,
          size: 200,
          model: {
            systemFlag: 1
          }
        },
        store: self.$store
      }).then(res => {
        this.types = res.data.tasks;
      });
    },
    onChange(e) {
      this.$emit("input", e);
    }
  }
};
</script>
